import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _62daf11e = () => interopDefault(import('../pages/error/index.vue' /* webpackChunkName: "pages/error/index" */))
const _17bfa4fe = () => interopDefault(import('../pages/sign-out/index.vue' /* webpackChunkName: "pages/sign-out/index" */))
const _71c1ad1e = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _0f563fe3 = () => interopDefault(import('../pages/users/create/index.vue' /* webpackChunkName: "pages/users/create/index" */))
const _3caddcc4 = () => interopDefault(import('../pages/users/_username/index.vue' /* webpackChunkName: "pages/users/_username/index" */))
const _32b1c6b6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _e0c0899c = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _62daf11e,
    name: "error"
  }, {
    path: "/sign-out",
    component: _17bfa4fe,
    name: "sign-out"
  }, {
    path: "/users",
    component: _71c1ad1e,
    name: "users"
  }, {
    path: "/users/create",
    component: _0f563fe3,
    name: "users-create"
  }, {
    path: "/users/:username",
    component: _3caddcc4,
    name: "users-username"
  }, {
    path: "/",
    component: _32b1c6b6,
    name: "index"
  }, {
    path: "/*",
    component: _e0c0899c,
    name: "all"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
